import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationBpiConstants {
    static STEP_TITLE = "Location";
    static PROPERTY_HEADING_LABEL = "Property details";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_OWNER_LABEL = "Copy owner to applicant";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static BPAMS_APPLICATION_ID_FORM_CONTROL_NAME = "bpamsApplicationId";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static IS_VERIFIED_FORM_CONTROL_NAME = "isVerified";
    static APPLICANT_FORM_CONTROL_NAME = "applicantRecipient";
    static APPLICANT_AGENT_FORM_CONTROL_NAME = "applicantAgentRecipient";
    static MARK_APPLICANT_AGENT_NA_FORM_CONTROL_NAME = "applicantAgentIsNull";
    static PROPERTIES_FORM_CONTROL_NAME = "properties";
    static CENTROID_FORM_CONTROL_NAME = "centroid";
    static BPAMS_APPLICATION_REFERENCE_NUMBER_CONTROL = "bpamsReferenceNumber";
    static DEFAULT_APPLICATION_TYPE = "Building plan inspectorate";
    static HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME = "hasBpamsReferenceNumber";
    static NOTE_FORM_CONTROL_NAME = "note";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static ERF_SIZE_CONTROL = "erfSize";
    static OWNER_CONTROL = "owners";
    static HAS_BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER = "Do you have a building plan reference number?";
    static DESCRIPTION_TEXT_PLACEHOLDER = "Description";
    static BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER = "Building plan reference number?";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size (m²)";
    static TITLE_DEED_TEXT_PLACEHOLDER = "Title deed";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static NO_OWNERS_SELECTED_MESSAGE = "Please select an owner to copy to applicant";
    static MULTIPLE_OWNERS_SELECTED_MESSAGE = "Multiple owners have been selected, please select only one to copy to applicant";
    static COPY_OWNER_TO_APPLICANT_SUCCESS_MESSAGE = "Owner successfully copied to applicant";
    static VERIFY_LABEL = "Verify";
    static VERIFICATION_MESSAGE_SUCCESS = "Reference number verification successful";
    static VERIFICATION_MESSAGE_FAILURE = "Reference number verification unsuccessful";
    static VERIFICATION_MESSAGE = "Building plan reference number verification was successful";
    static MISSING_REFERENCE_NUMBER = "Building plan reference number " + SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static APPLICANT_FORM_NAME = "applicantForm";
    static APPLICANT_AGENT_FORM_NAME = "applicantAgentForm";
    static PROPERTY_FORM_NAME = "propertiesForm";
    static NOTE_FORM_GROUP_NAME = "notesForm";
    static DOCUMENTS_FORM_GROUP_NAME = "documentForm";
    static VALIDATION_MESSAGES = {
        bpamsApplicationReferenceNumber: {
            required: `BPAMS application reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        hasBpamsReferenceNumber: {
            required: `Response ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
